// This icon file is generated automatically.
var EditPenFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.82 18.12L.5 20l1.8-6.64 4.52 4.76zM19.2 5.09l-1.52 1.6-4.52-4.76 1.52-1.6s.72-.76 1.46.02l2.98 3.13c.8.85.08 1.61.08 1.61zm-1.97 2.08L7.27 17.64l-4.53-4.75L12.7 2.4l4.53 4.76z" } }] }, "name": "edit-pen", "theme": "filled" };
export default EditPenFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/EditPenFilled.js
// module id = 2592
// module chunks = 0